// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"styles_checkboxes__2PGHe"};